const greeting = {
  subTitle:
    "A passionate individual who always thrives to work on end to end products which develop sustainable and scalable social and technical systems to create impact.",
  resumeLink:
    "https://drive.google.com/file/d/1MWpR8tgyzeKDdZDU6rVwhVxH5xjmrS8J/view?usp=sharing",
};

const socialMediaLinks = [
  { name: "Github", link: "https://github.com/niteshpurohit" },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/niteshpurohit/",
  },
  { name: "Gmail", link: "mailto:nitesh.purohit.it@gmail.com" },
];

const skills = {
  data: [
    {
      title: "Full Stack Development",
      skills: [
        "⚡ Building responsive website using React, Angular and Flutter",
        "⚡ Developing mobile applications using Flutter and Android",
        "⚡ Creating robust middleware using Ruby on Rails, NodeJS and Go",
        "⚡ Integration of third party services such as Firebase/ AWS / GCP",
        "⚡ Experience with RESTful API and GraphQL",
        "⚡ Experience with WebSockets and Socket.io",
      ],
      softwareSkills: [
        { skillName: "Ruby" },
        { skillName: "Ruby on Rails" },
        { skillName: "GraphQL" },
        { skillName: "C++" },
        { skillName: "Go" },
        { skillName: "JavaScript" },
        { skillName: "React" },
        { skillName: "Angular" },
        { skillName: "NodeJS" },
        { skillName: "Flutter" },
      ],
    },
    {
      title: "Cloud Infra-Architecture",
      skills: [
        "⚡ Experience working on multiple cloud platforms",
        "⚡ Using terraform/aws cdk to deploy scalable infrastructure",
        "⚡ Experience with Docker and Kubernetes",
        "⚡ Experience with CI/CD tools like Jenkins, Github Actions, Buildkite and CircleCI",
        "⚡ Experience with monitoring tools like New Relic, Datadog and Sentry",
        "⚡ Experience with databases like PostgreSQL, MongoDB, MySQL and DynamoDB and caching systems like Redis",
      ],
      softwareSkills: [
        { skillName: "AWS" },
        { skillName: "GCP" },
        { skillName: "Firebase" },
        { skillName: "PostgreSQL" },
        { skillName: "MongoDB" },
        { skillName: "Redis" },
        { skillName: "Docker" },
        { skillName: "Terraform" },
        { skillName: "Github Actions" },
        { skillName: "Jenkins" },
        { skillName: "CircleCI" },
        { skillName: "New Relic" },
        { skillName: "Datadog" },
        { skillName: "Sentry" },
      ],
    },
    {
      title: "Data Science & ETL",
      skills: [
        "⚡ Developing highly scalable production ready scripts for data processing",
        "⚡ Experience in building ETL pipelines",
      ],
      softwareSkills: [
        { skillName: "AWS Athena" },
        { skillName: "AWS Kinesis & Firehose" },
        { skillName: "Python" },
        { skillName: "Scala" },
        { skillName: "Apache Spark" },
        { skillName: "Databricks" },
      ],
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Jodhpur National University",
      subtitle: "M.Tech. in Computer Science",
      duration: "2012 - 2014",
      grade: "Coursework completed | No degree",
      descriptions: [
        "⚡ Advanced coursework completed; Dissertation topic: Universal driver layer in ARM processors using C++",
      ],
      website_link: "https://jodhpurnationaluniversity.co.in/",
    },
    {
      title: "Jodhpur National University",
      subtitle: "B.Tech. in Information Technology",
      duration: "2008 - 2012",
      grade: "74%",
      descriptions: [
        "⚡ I have studied basic software engineering subjects like DS, Algorithms, DBMS, OS, CA, AI etc.",
        "⚡ Apart from this, i have done courses on Robotics, Embedded Systems, IoT, Cloud Computing and Full Stack Development.",
        "⚡ I have also done some projects on Data Science and Machine Learning.",
      ],
      website_link: "https://jodhpurnationaluniversity.co.in/",
    },
  ],
};

const experience = {
  sections: [
    {
      experiences: [
        {
          title: "Senior Software Engineer",
          company: "Lillio (Formerly Himama)",
          company_url: "https://lillio.com",
          duration: "November 2021 - Present",
          location: "Toronto, Canada",
          description:
            "Working on various projects related to Web Development, GraphQL using Ruby on Rails and React",
        },
        {
          title: "Principal Engineer",
          company: "Jobstreet Malaysia",
          company_url: "https://jobstreet.com.my",
          duration: "October 2019 - November 2021",
          location: "Kuala Lumpur, Malaysia",
          description:
            "Worked on various projects related to Web Development, Data Science and Cloud Infrastructure using NodeJS, React, Python, Go and AWS",
        },
        {
          title: "Head of Engineering",
          company: "AJM Softwares",
          company_url: "https://ajm.in",
          duration: "November 2018 - October 2019",
          location: "Jodhpur, Rajasthan, India",
          description:
            "Worked on various projects and managed multiple teams in domains such as Web Development, Mobile Development, Data Science, and Cloud Infrastructure.",
        },
        {
          title: "Development Manager",
          company: "Finterra",
          company_url: "https://finterra.org",
          duration: "January 2018 - October 2018",
          location: "Kuala Lumpur, Malaysia",
          description:
            "Worked on various projects and managed multiple teams in domains such as Web Development, Mobile Development, Cryptocurrency and Web3.",
        },
        {
          title: "Sole Proprietor",
          company: "AWR Technologies",
          company_url: "https://www.awrtechnologies.com",
          duration: "Marcg 2011 - December 2017",
          location: "Jodhpur, Rajasthan, India",
          description:
            "Worked on various projects and managed multiple teams in domains such as Web Development, Mobile Development, Data Science, and Cloud Infrastructure.",
        },
      ],
    },
  ],
};

const contactPageData = {
  contactSection: {
    description:
      "Want hire me? or just want to say hi? My inbox is open for all.",
  },
  blogSection: {
    link: "https://blog.niteshpurohit.com/",
  },
};

export {
  greeting,
  socialMediaLinks,
  skills,
  degrees,
  experience,
  contactPageData,
};
